/* STORES */
import { useConfigStore } from "@/stores/config"

// Read once at boot: the first navigation redirects and drops the query string
const gotoParam = new URLSearchParams(window.location.search).get("goto")

/**
 * Outside production only: /?goto=screening-error-connection previews the Scan
 * connection/VPN error page, without needing a Scan
 */
export const isScreeningErrorConnectionPreview = () =>
  useConfigStore().environment !== "production" &&
  gotoParam === "screening-error-connection"
